 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A00_AMERICAN_EXPEDITIONARY_FORCE from '@/components/000_AMERICAN_EXPEDITIONARY_FORCE'
 import A00A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/000a_AMERICAN_EXPEDITIONARY_FORCE'
 import A0B1_AMERICAN_EXPEDITIONARY_FORCE from '@/components/00b1_AMERICAN_EXPEDITIONARY_FORCE'
 import A0B_AMERICAN_EXPEDITIONARY_FORCE from '@/components/00b_AMERICAN_EXPEDITIONARY_FORCE'
 import A0C_AMERICAN_EXPEDITIONARY_FORCE from '@/components/00c_AMERICAN_EXPEDITIONARY_FORCE'
 import A0D_AMERICAN_EXPEDITIONARY_FORCE from '@/components/00d_AMERICAN_EXPEDITIONARY_FORCE'
 import A1A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01a_AMERICAN_EXPEDITIONARY_FORCE'
 import A1B_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01b_AMERICAN_EXPEDITIONARY_FORCE'
 import A1BA_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01b-a_AMERICAN_EXPEDITIONARY_FORCE'
 import A1C_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01c_AMERICAN_EXPEDITIONARY_FORCE'
 import A1D_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01d_AMERICAN_EXPEDITIONARY_FORCE'
 import A1DA_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01d-a_AMERICAN_EXPEDITIONARY_FORCE'
 import A1G_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01g_AMERICAN_EXPEDITIONARY_FORCE'
 import A1GA_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01g-a_AMERICAN_EXPEDITIONARY_FORCE'
 import A1I_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01i_AMERICAN_EXPEDITIONARY_FORCE'
 import A1J_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01j_AMERICAN_EXPEDITIONARY_FORCE'
 import A1K_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01k_AMERICAN_EXPEDITIONARY_FORCE'
 import A1L_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01l_AMERICAN_EXPEDITIONARY_FORCE'
 import A1M_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01m_AMERICAN_EXPEDITIONARY_FORCE'
 import A1N_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01n_AMERICAN_EXPEDITIONARY_FORCE'
 import A1O_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01o_AMERICAN_EXPEDITIONARY_FORCE'
 import A1P_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01p_AMERICAN_EXPEDITIONARY_FORCE'
 import A1Q_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01q_AMERICAN_EXPEDITIONARY_FORCE'
 import A1R_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01r_AMERICAN_EXPEDITIONARY_FORCE'
 import A1S_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01s_AMERICAN_EXPEDITIONARY_FORCE'
 import A1T_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01t_AMERICAN_EXPEDITIONARY_FORCE'
 import A1U_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01u_AMERICAN_EXPEDITIONARY_FORCE'
 import A1V_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01v_AMERICAN_EXPEDITIONARY_FORCE'
 import A1W_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01w_AMERICAN_EXPEDITIONARY_FORCE'
 import A1X_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01x_AMERICAN_EXPEDITIONARY_FORCE'
 import A1Y_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01y_AMERICAN_EXPEDITIONARY_FORCE'
 import A1YY_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01yy_AMERICAN_EXPEDITIONARY_FORCE'
 import A1Z_AMERICAN_EXPEDITIONARY_FORCE from '@/components/01z_AMERICAN_EXPEDITIONARY_FORCE'
 import A2A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02a_AMERICAN_EXPEDITIONARY_FORCE'
 import A2B_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02b_AMERICAN_EXPEDITIONARY_FORCE'
 import A2C_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02c_AMERICAN_EXPEDITIONARY_FORCE'
 import A2D_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02d_AMERICAN_EXPEDITIONARY_FORCE'
 import A2E_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02e_AMERICAN_EXPEDITIONARY_FORCE'
 import A2F_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02f_AMERICAN_EXPEDITIONARY_FORCE'
 import A2FA_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02f-a_AMERICAN_EXPEDITIONARY_FORCE'
 import A2G_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02g_AMERICAN_EXPEDITIONARY_FORCE'
 import A2H_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02h_AMERICAN_EXPEDITIONARY_FORCE'
 import A2I_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02i_AMERICAN_EXPEDITIONARY_FORCE'
 import A2J_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02j_AMERICAN_EXPEDITIONARY_FORCE'
 import A2K_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02k_AMERICAN_EXPEDITIONARY_FORCE'
 import A2L_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02l_AMERICAN_EXPEDITIONARY_FORCE'
 import A2M_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02m_AMERICAN_EXPEDITIONARY_FORCE'
 import A2N_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02n_AMERICAN_EXPEDITIONARY_FORCE'
 import A2NA_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02n-a_AMERICAN_EXPEDITIONARY_FORCE'
 import A2O_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02o_AMERICAN_EXPEDITIONARY_FORCE'
 import A2P_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02p_AMERICAN_EXPEDITIONARY_FORCE'
 import A2Q_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02q_AMERICAN_EXPEDITIONARY_FORCE'
 import A2R_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02r_AMERICAN_EXPEDITIONARY_FORCE'
 import A2S_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02s_AMERICAN_EXPEDITIONARY_FORCE'
 import A2T_AMERICAN_EXPEDITIONARY_FORCE from '@/components/02t_AMERICAN_EXPEDITIONARY_FORCE'
 import A3A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03a_AMERICAN_EXPEDITIONARY_FORCE'
 import A3B_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03b_AMERICAN_EXPEDITIONARY_FORCE'
 import A3C_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03c_AMERICAN_EXPEDITIONARY_FORCE'
 import A3D_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03d_AMERICAN_EXPEDITIONARY_FORCE'
 import A3E_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03e_AMERICAN_EXPEDITIONARY_FORCE'
 import A3F_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03f_AMERICAN_EXPEDITIONARY_FORCE'
 import A3G_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03g_AMERICAN_EXPEDITIONARY_FORCE'
 import A3H_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03h_AMERICAN_EXPEDITIONARY_FORCE'
 import A3I_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03i_AMERICAN_EXPEDITIONARY_FORCE'
 import A3J_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03j_AMERICAN_EXPEDITIONARY_FORCE'
 import A3K_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03k_AMERICAN_EXPEDITIONARY_FORCE'
 import A3L_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03l_AMERICAN_EXPEDITIONARY_FORCE'
 import A3M_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03m_AMERICAN_EXPEDITIONARY_FORCE'
 import A3N_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03n_AMERICAN_EXPEDITIONARY_FORCE'
 import A3O_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03o_AMERICAN_EXPEDITIONARY_FORCE'
 import A3P_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03p_AMERICAN_EXPEDITIONARY_FORCE'
 import A3Q_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03q_AMERICAN_EXPEDITIONARY_FORCE'
 import A3R_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03r_AMERICAN_EXPEDITIONARY_FORCE'
 import A3S_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03s_AMERICAN_EXPEDITIONARY_FORCE'
 import A3T_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03t_AMERICAN_EXPEDITIONARY_FORCE'
 import A3U_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03u_AMERICAN_EXPEDITIONARY_FORCE'
 import A3V_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03v_AMERICAN_EXPEDITIONARY_FORCE'
 import A3W_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03w_AMERICAN_EXPEDITIONARY_FORCE'
 import A3X_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03x_AMERICAN_EXPEDITIONARY_FORCE'
 import A3Y_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03y_AMERICAN_EXPEDITIONARY_FORCE'
 import A3YY_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03yy_AMERICAN_EXPEDITIONARY_FORCE'
 import A3Z01_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03z01_AMERICAN_EXPEDITIONARY_FORCE'
 import A3Z02_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03z02_AMERICAN_EXPEDITIONARY_FORCE'
 import A3Z03_AMERICAN_EXPEDITIONARY_FORCE from '@/components/03z03_AMERICAN_EXPEDITIONARY_FORCE'
 import A4A_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04a_AMERICAN_EXPENDITIONARY_FORCE'
 import A4B_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04b_AMERICAN_EXPENDITIONARY_FORCE'
 import A4C_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04c_AMERICAN_EXPENDITIONARY_FORCE'
 import A4E_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04e_AMERICAN_EXPENDITIONARY_FORCE'
 import A4F_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04f_AMERICAN_EXPENDITIONARY_FORCE'
 import A4H_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04h_AMERICAN_EXPENDITIONARY_FORCE'
 import A4I_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04i_AMERICAN_EXPENDITIONARY_FORCE'
 import A4J_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04j_AMERICAN_EXPENDITIONARY_FORCE'
 import A4K_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04k_AMERICAN_EXPENDITIONARY_FORCE'
 import A4L_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04l_AMERICAN_EXPENDITIONARY_FORCE'
 import A4M_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04m_AMERICAN_EXPENDITIONARY_FORCE'
 import A4N_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04n_AMERICAN_EXPENDITIONARY_FORCE'
 import A4O_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04o_AMERICAN_EXPENDITIONARY_FORCE'
 import A4P_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04p_AMERICAN_EXPENDITIONARY_FORCE'
 import A4Q_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04q_AMERICAN_EXPENDITIONARY_FORCE'
 import A4R_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04r_AMERICAN_EXPENDITIONARY_FORCE'
 import A4S_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04s_AMERICAN_EXPENDITIONARY_FORCE'
 import A4T_AMERICAN_EXPENDITIONARY_FORCE from '@/components/04t_AMERICAN_EXPENDITIONARY_FORCE'
 import A5A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05a_AMERICAN_EXPEDITIONARY_FORCE'
 import A5B_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05b_AMERICAN_EXPEDITIONARY_FORCE'
 import A5C_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05c_AMERICAN_EXPEDITIONARY_FORCE'
 import A5D_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05d_AMERICAN_EXPEDITIONARY_FORCE'
 import A5E_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05e_AMERICAN_EXPEDITIONARY_FORCE'
 import A5F_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05f_AMERICAN_EXPEDITIONARY_FORCE'
 import A5G_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05g_AMERICAN_EXPEDITIONARY_FORCE'
 import A5H_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05h_AMERICAN_EXPEDITIONARY_FORCE'
 import A5I_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05i_AMERICAN_EXPEDITIONARY_FORCE'
 import A5J_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05j_AMERICAN_EXPEDITIONARY_FORCE'
 import A5K_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05k_AMERICAN_EXPEDITIONARY_FORCE'
 import A5L_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05l_AMERICAN_EXPEDITIONARY_FORCE'
 import A5M_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05m_AMERICAN_EXPEDITIONARY_FORCE'
 import A5N_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05n_AMERICAN_EXPEDITIONARY_FORCE'
 import A5O_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05o_AMERICAN_EXPEDITIONARY_FORCE'
 import A5P_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05p_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Q_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05q_AMERICAN_EXPEDITIONARY_FORCE'
 import A5R_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05r_AMERICAN_EXPEDITIONARY_FORCE'
 import A5S_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05s_AMERICAN_EXPEDITIONARY_FORCE'
 import A5T_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05t_AMERICAN_EXPEDITIONARY_FORCE'
 import A5U_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05u_AMERICAN_EXPEDITIONARY_FORCE'
 import A5V_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05v_AMERICAN_EXPEDITIONARY_FORCE'
 import A5W_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05w_AMERICAN_EXPEDITIONARY_FORCE'
 import A5X_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05x_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Y_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05y_AMERICAN_EXPEDITIONARY_FORCE'
 import A5YY_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05yy_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z001_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z001_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z002_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z002_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z003_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z003_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z004_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z004_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z005_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z005_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z006_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z006_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z007_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z007_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z008_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z008_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z009_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z009_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z010_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z010_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z011_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z011_AMERICAN_EXPEDITIONARY_FORCE'
 import A5Z012_AMERICAN_EXPEDITIONARY_FORCE from '@/components/05z012_AMERICAN_EXPEDITIONARY_FORCE'
 import A6A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06a_AMERICAN_EXPEDITIONARY_FORCE'
 import A6B_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06b_AMERICAN_EXPEDITIONARY_FORCE'
 import A6C_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06c_AMERICAN_EXPEDITIONARY_FORCE'
 import A6D_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06d_AMERICAN_EXPEDITIONARY_FORCE'
 import A6E_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06e_AMERICAN_EXPEDITIONARY_FORCE'
 import A6F_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06f_AMERICAN_EXPEDITIONARY_FORCE'
 import A6G_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06g_AMERICAN_EXPEDITIONARY_FORCE'
 import A6H_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06h_AMERICAN_EXPEDITIONARY_FORCE'
 import A6I_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06i_AMERICAN_EXPEDITIONARY_FORCE'
 import A6J_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06j_AMERICAN_EXPEDITIONARY_FORCE'
 import A6K_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06k_AMERICAN_EXPEDITIONARY_FORCE'
 import A6L_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06l_AMERICAN_EXPEDITIONARY_FORCE'
 import A6M_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06m_AMERICAN_EXPEDITIONARY_FORCE'
 import A6MA_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06m-a_AMERICAN_EXPEDITIONARY_FORCE'
 import A6N_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06n_AMERICAN_EXPEDITIONARY_FORCE'
 import A6O_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06o_AMERICAN_EXPEDITIONARY_FORCE'
 import A6P_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06p_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Q_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06q_AMERICAN_EXPEDITIONARY_FORCE'
 import A6R_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06r_AMERICAN_EXPEDITIONARY_FORCE'
 import A6S_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06s_AMERICAN_EXPEDITIONARY_FORCE'
 import A6T_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06t_AMERICAN_EXPEDITIONARY_FORCE'
 import A6UA_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06ua_AMERICAN_EXPEDITIONARY_FORCE'
 import A6UB_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06ub_AMERICAN_EXPEDITIONARY_FORCE'
 import A6UC_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06uc_AMERICAN_EXPEDITIONARY_FORCE'
 import A6UD_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06ud_AMERICAN_EXPEDITIONARY_FORCE'
 import A6V_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06v_AMERICAN_EXPEDITIONARY_FORCE'
 import A6W_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06w_AMERICAN_EXPEDITIONARY_FORCE'
 import A6X_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06x_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Y_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06y_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z01_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z01_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z01A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z01-a_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z02_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z02_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z03_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z03_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z04_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z04_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z05_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z05_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z06_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z06_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z07A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z07a_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z07B_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z07b_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z07C_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z07c_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z08_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z08_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z09_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z09_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z10_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z10_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z11_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z11_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z12_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z12_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z13_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z13_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z14_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z14_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z15_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z15_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z16_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z16_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z17_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z17_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z18_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z18_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z19_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z19_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z20_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z20_AMERICAN_EXPEDITIONARY_FORCE'
 import A6Z21_AMERICAN_EXPEDITIONARY_FORCE from '@/components/06z21_AMERICAN_EXPEDITIONARY_FORCE'
 import A7A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07a_AMERICAN_EXPEDITIONARY_FORCE'
 import A7B_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07b_AMERICAN_EXPEDITIONARY_FORCE'
 import A7C_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07c_AMERICAN_EXPEDITIONARY_FORCE'
 import A7D_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07d_AMERICAN_EXPEDITIONARY_FORCE'
 import A7E_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07e_AMERICAN_EXPEDITIONARY_FORCE'
 import A7F_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07f_AMERICAN_EXPEDITIONARY_FORCE'
 import A7G_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07g_AMERICAN_EXPEDITIONARY_FORCE'
 import A7H_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07h_AMERICAN_EXPEDITIONARY_FORCE'
 import A7I_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07i_AMERICAN_EXPEDITIONARY_FORCE'
 import A7J_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07j_AMERICAN_EXPEDITIONARY_FORCE'
 import A7K_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07k_AMERICAN_EXPEDITIONARY_FORCE'
 import A7L_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07l_AMERICAN_EXPEDITIONARY_FORCE'
 import A7M_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07m_AMERICAN_EXPEDITIONARY_FORCE'
 import A7MA_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07m-a_AMERICAN_EXPEDITIONARY_FORCE'
 import A7N_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07n_AMERICAN_EXPEDITIONARY_FORCE'
 import A7O_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07o_AMERICAN_EXPEDITIONARY_FORCE'
 import A7P_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07p_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Q_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07q_AMERICAN_EXPEDITIONARY_FORCE'
 import A7R_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07r_AMERICAN_EXPEDITIONARY_FORCE'
 import A7S_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07s_AMERICAN_EXPEDITIONARY_FORCE'
 import A7T_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07t_AMERICAN_EXPEDITIONARY_FORCE'
 import A7U_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07u_AMERICAN_EXPEDITIONARY_FORCE'
 import A7V_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07v_AMERICAN_EXPEDITIONARY_FORCE'
 import A7W_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07w_AMERICAN_EXPEDITIONARY_FORCE'
 import A7X_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07x_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Y_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07y_AMERICAN_EXPEDITIONARY_FORCE'
 import A7YY_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07yy_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z01_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z01_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z02_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z02_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z03_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z03_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z04_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z04_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z05_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z05_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z06_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z06_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z07_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z07_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z08_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z08_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z09_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z09_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z10_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z10_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z11_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z11_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z12_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z12_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z13_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z13_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z14_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z14_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z15_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z15_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z16_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z16_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z16A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z16a_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z17_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z17_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z18_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z18_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z19_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z19_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z20_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z20_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z21_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z21_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z22_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z22_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z23_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z23_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z24_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z24_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z25_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z25_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z25A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z25-a_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z27_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z27_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z28_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z28_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z29_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z29_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z30_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z30_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z32_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z32_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z33_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z33_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z34_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z34_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z35_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z35_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z36_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z36_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z37_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z37_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z38_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z38_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z39_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z39_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z40_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z40_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z41_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z41_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z42_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z42_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z44_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z44_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z45_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z45_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z46_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z46_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z47_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z47_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z48_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z48_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z49_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z49_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z50_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z50_AMERICAN_EXPEDITIONARY_FORCE'
 import A7Z51_AMERICAN_EXPEDITIONARY_FORCE from '@/components/07z51_AMERICAN_EXPEDITIONARY_FORCE'
 import A8A_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08a_AMERICAN_EXPEDITIONARY_FORCE'
 import A8B_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08b_AMERICAN_EXPEDITIONARY_FORCE'
 import A8C_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08c_AMERICAN_EXPEDITIONARY_FORCE'
 import A8D_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08d_AMERICAN_EXPEDITIONARY_FORCE'
 import A8E_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08e_AMERICAN_EXPEDITIONARY_FORCE'
 import A8F_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08f_AMERICAN_EXPEDITIONARY_FORCE'
 import A8G_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08g_AMERICAN_EXPEDITIONARY_FORCE'
 import A8H_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08h_AMERICAN_EXPEDITIONARY_FORCE'
 import A8I_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08i_AMERICAN_EXPEDITIONARY_FORCE'
 import A8J_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08j_AMERICAN_EXPEDITIONARY_FORCE'
 import A8L_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08l_AMERICAN_EXPEDITIONARY_FORCE'
 import A8M_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08m_AMERICAN_EXPEDITIONARY_FORCE'
 import A8N_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08n_AMERICAN_EXPEDITIONARY_FORCE'
 import A8O_AMERICAN_EXPEDITIONARY_FORCE from '@/components/08o_AMERICAN_EXPEDITIONARY_FORCE'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/000_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "000_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A00_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/000a_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "000a_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A00A_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/00b1_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "00b1_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A0B1_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/00b_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "00b_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A0B_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/00c_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "00c_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A0C_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/00d_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "00d_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A0D_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01a_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01a_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1A_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01b_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01b_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1B_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01b-a_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01b-a_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1BA_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01c_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01c_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1C_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01d_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01d_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1D_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01d-a_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01d-a_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1DA_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01g_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01g_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1G_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01g-a_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01g-a_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1GA_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01i_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01i_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1I_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01j_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01j_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1J_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01k_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01k_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1K_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01l_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01l_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1L_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01m_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01m_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1M_AMERICAN_EXPEDITIONARY_FORCE
 		},
 		{
 			"path" : "/01n_AMERICAN_EXPEDITIONARY_FORCE",
 			"name" : "01n_AMERICAN_EXPEDITIONARY_FORCE",
 			"component" : A1N_AMERICAN_EXPEDITIONARY_FORCE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js